angular.module('clients')
    .component('contactTypePicker', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            required: "<?"
        },
        templateUrl: "app/clients/contact-type-picker/contact-type-picker.html",
        controller: function () {
            const ctrl = this

            ctrl.items = ['PHONE', 'EMAIL', 'WEBSITE', 'OTHER']

            ctrl.$onInit = () => {
                ctrl.required = ctrl.required || false
                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue)
                ctrl.ngModelCtrl.$parsers.push(viewValue => viewValue)
            }

            ctrl.onSelectionChanged = ($item, $model) => {
                ctrl.ngModelCtrl.$setViewValue($item)
                ctrl.ngModelCtrl.$validate()
                ctrl.ngModelCtrl.$render()
            }
        }
    })
